import { FC, ReactElement, useEffect, useRef } from 'react';

import { RaaDialog } from 'raa-react';

export const PersistentLinkDialog: FC<{ link: string; unsetDialog: () => void }> = ({
  link,
  unsetDialog
}): ReactElement => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.select();
  }, []);

  const copyLink = async () => {
    if (inputRef.current) {
      inputRef.current.select();

      try {
        await navigator.clipboard.writeText(link);
        unsetDialog();
      } catch (err) {
        console.error('Failed to copy: ', err);
      }
    }
  };

  return (
    <RaaDialog close={unsetDialog}>
      <label className="tw-heading-md">
        Kopiera länk till urklipp
        <input
          ref={inputRef}
          value={link}
          type="text"
          readOnly
          className="tw-w-full tw-text-size-0.813 tw-outline-none"
        />
      </label>

      <button className="raa-button raa-button-secondary tw-w-full tw-mt-4" onClick={copyLink}>
        Kopiera och stäng
      </button>
    </RaaDialog>
  );
};

export const PersistentLinkErrorDialog: FC<{ unsetDialog: () => void }> = ({ unsetDialog }): ReactElement => {
  return (
    <RaaDialog
      header="Något gick fel"
      cancel={unsetDialog}
      cancelButtonText="stäng"
      ariaDescribedBy="dialog-description"
      close={unsetDialog}
    >
      <p id="dialog-description" className="tw-mt-4">
        Det gick inte att skapa en persistent länk just nu. Försök igen senare.
      </p>
    </RaaDialog>
  );
};
